module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This series of photographs is meant to supplement the descriptions of cat musculature found in "), _c('em', [_vm._v("Hyman’s Comparative Vertebrate Anatomy")]), _vm._v(", third edition, edited by Marvalee Wake, or any other good comparative anatomy text. It is not to be used as the sole text for the laboratory, but only to assist the student in locating muscles with the aid of instructions and fuller descriptions in a basic text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the list of muscles on each page of this atlas are the page numbers in the Wake text on which those muscles are discussed. The page references to the Wake text are also listed in the index for this atlas, together with information on origin, insertion, and action.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These photographs should make the descriptions in Wake or any other comparative anatomy text more vivid and clear, for the student can use these photographs to see what the muscle looks like before starting dissection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All dissection and photography were done by Gordon M. Greenblatt.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17408612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226112398_06_pre.vue
// module id = 66
// module chunks = 0